import React from "react";
import { useField } from "formik";
import { Checkbox, FormControlLabel, Box, Typography } from "@mui/material";

interface CheckboxProps {
  label: string;
  name: string;
  required?: boolean;
  disabled?: boolean;
}

export default function CustomCheckbox({
  label,
  name,
  required,
  disabled
}: CheckboxProps) {
  const [field, meta, helpers] = useField(name);
  const showError = meta.touched && meta.error;

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={!!field.value}
            onChange={() => helpers.setValue(!field.value)}
            name={name}
            id={name}
            disabled={disabled}
            color="primary"
          />
        }
        label={
          <Typography variant="body2">
            {label}
            {required && (
              <span style={{ color: "red", marginLeft: 4 }}>*</span>
            )}
          </Typography>
        }
      />
      {showError && (
        <Typography color="error" variant="caption" sx={{ ml: 1 }}>
          {meta.error}
        </Typography>
      )}
    </Box>
  );
}
